import React from "react";
import { CreateNFeContext } from "../../../Context";
import LoadingInput from "../../../../../../../_components/LoadingInput";
import Text from "../../../../../../../_components/Text";
import CheckBox from "../../../../../../../_components/Checkbox";

export default (props) => {
  const context = React.useContext(CreateNFeContext);
  const [showRefKey, setShowRefKey] = React.useState(false);
  function onChange(e) {
    const { nfe } = context;
    const key = e.target.value.replace(/[^0-9]/g, "");
    if (key.length > 44) {
      return;
    }
    if (key.length < 44) {
      e.target.classList.add("is-invalid");
    }
    nfe.identification.ref_key = key;
    context.handlers.updateNFeData(nfe);
  }
  const show =
    context.nfe.identification.fin_nfe !== "1" ||
    context.nfe.identification.ind_pres === "4" ||
    context.nfe.identification.ind_pres === "5" ||
    showRefKey;
  return (
    <React.Fragment>
      <CheckBox
        onClick={() => setShowRefKey(!showRefKey)}
        checked={showRefKey}
        label="Informar chave de referência"
      />
      <div className={show ? "d-block" : "d-none"}>
        <Text color="primary">Chave de Referência da NF-e/NFC-e</Text>
        <LoadingInput
          onChange={onChange}
          value={context.nfe.identification.ref_key}
        />
        <Text className="text-right">
          {context.nfe.identification.ref_key
            ? context.nfe.identification.ref_key.length
            : 0}
          /44
        </Text>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/RefKey/index.jsx